import { render, staticRenderFns } from "./levels.vue?vue&type=template&id=38f2b3c9&scoped=true&"
import script from "./levels.vue?vue&type=script&lang=js&"
export * from "./levels.vue?vue&type=script&lang=js&"
import style0 from "./levels.vue?vue&type=style&index=0&id=38f2b3c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2b3c9",
  null
  
)

export default component.exports